<template>
  <div class="machines-list">

    <template v-if="warningMachines">
      <h1 class="title is-3 no-margin text-center">ALERTS</h1>
      <table class="table is-hoverable is-bordered alerts">
        <thead>
          <tr>
            <th>Name</th>
            <th>SMU</th>
            <th>Next Service</th>
            <th>Alert(s)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="m of warningMachines" :key="m._id"
            @click="viewMachine(m)"
            :class="{warning: m.service === 'due' || m.repairs, danger: m.service === 'overdue' || m.repairsUrgent}"
          >
            <td>{{ m.name }}</td>
            <td>{{ m.smu | prettyNumber }} {{ m.units }}</td>
            <td>{{ m.nextService | prettyNumber }}</td>
            <td>
              <div class="tags">
                <span v-if="m.service === 'due'" class="tag is-warning">service due</span>
                <span v-else-if="m.service === 'overdue'" class="tag is-danger">SERVICE OVERDUE</span>

                <span v-if="m.repairsUrgent" class="tag is-danger">URGENT REPAIRS</span>
                <span v-else-if="m.repairs" class="tag is-warning">repairs needed</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
    </template>

    <template v-if="showAll">
      <div class="flex">
        <b-input v-model="searchStr" placeholder="search" />
        <div v-if="isAdmin && showAdd" class="flex-1 text-right">
          <button v-if="isAdmin" class="button is-success" @click="$router.push('/add-machine')">Add Machine</button>
        </div>
      </div>

      <table v-if="machines && machines.length" class="table is-hoverable is-striped is-bordered is-clickable">
        <thead v-if="showTableHead">
          <tr>
            <th>Name</th>
            <th v-if="showSmu">SMU</th>
            <th v-if="showNextService">Next Service</th>
            <th v-if="isAdmin && showEdit"></th>
          </tr>
        </thead>
        <tbody v-for="(machines, category) in filteredMachines" :key="category">
          <tr class="category">
            <th >{{ category }}</th>
            <th v-if="showSmu">SMU</th>
            <th v-if="showNextService">Next Service</th>
            <th v-if="isAdmin && showEdit"></th>
          </tr>
          <tr v-for="m of machines" :key="m._id">
            <td @click="viewMachine(m)">{{ m.name }}</td>
            <td v-if="showSmu" @click="viewMachine(m)">{{ m.smu | prettyNumber }} {{ m.units }}</td>
            <td v-if="showNextService" @click="viewMachine(m)">{{ m.nextService | prettyNumber }}</td>
            <td v-if="isAdmin && showEdit">
              <div class="buttons">
                <button class="button is-small" @click.prevent="editMachine(m)">edit details</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <div v-if="machines === null">
      <loading />
    </div>
    <div v-else-if="!machines.length" class="pad text-center has-text-grey-light">
      There are no machines
    </div>

  </div>
</template>

<script>
export default {
  name: 'MachinesList',
  props: {
    showAdd: { default: true },
    showEdit: { default: true },
    showAll: { default: true },
    showWarnings: { default: false },
    showTableHead: { default: false },
    showSmu: { default: true },
    showNextService: { default: true }
  },
  data () {
    return {
      searchStr: '',
      machines: null,
      filteredMachines: {},
      timer: null,
      repairs: null,
      warningMachines: null
    }
  },
  computed: {
    isAdmin () { return this.$store.getters.isAdmin }
  },
  watch: {
    searchStr () {
      if (!this.machines) {
        return
      }
      clearTimeout(this.timer)
      this.timer = setTimeout(this.filterMachines, 500)
    }
  },
  created () {
    this.subs.machines = this.$firestore.collection('machines')
      .orderBy('name')
      .onSnapshot(snapshot => {
        this.machines = this.$utils.snapshotToArr(snapshot)
        this.updateWarningMachines()
        this.filterMachines()
      })

    if (this.showWarnings) {
      this.subs.machineRepairs = this.$firestore.collection('machineRepairs')
        .where('timestampFixed', '==', 0)
        .onSnapshot(snapshot => {
          this.repairs = this.$utils.snapshotToArr(snapshot)
          this.updateWarningMachines()
        })
    }
  },
  methods: {
    filterMachines () {
      let arr = null
      let str = this.searchStr.trim().toLocaleLowerCase()
      if (str.length) {
        arr = this.machines.filter(m => {
          return m.name.toLocaleLowerCase().indexOf(str) >= 0 || `${m.category}`.toLocaleLowerCase().indexOf(str) >= 0
        })
      } else {
        arr = this.machines
      }
      let noCatArr = []
      let obj = {}
      for (let m of arr) {
        if (m.category) {
          if (!obj[m.category]) {
            obj[m.category] = [m]
          } else {
            obj[m.category].push(m)
          }
        } else {
          noCatArr.push(m)
        }
      }
      if (noCatArr.length) {
        obj['Other'] = noCatArr
      }
      this.filteredMachines = obj
    },
    updateWarningMachines () {
      if (!this.showWarnings || !this.machines) {
        return
      }

      let obj = {}

      for (let machine of this.machines) {
        if (machine.nextService === 0) continue

        if (machine.smu > machine.nextService) {
          machine.service = 'overdue'
        } else if (machine.smu >= machine.nextService - machine.serviceWarning) {
          machine.service = 'due'
        } else {
          delete machine.service
        }
        if (machine.service) {
          obj[machine._id] = machine
        }
      }

      if (this.repairs) {
        for (let r of this.repairs) {
          let machine = obj[r.machineId]
          if (!machine) {
            machine = this.machines.find(m => m._id === r.machineId)
            if (!machine) {
              continue
            }
            obj[r.machineId] = machine
          }
          machine.repairs = true
          if (r.urgent) {
            machine.repairsUrgent = true
          }
        }
      }

      this.warningMachines = obj
    },
    viewMachine (machine) {
      this.$emit('selected', machine)
    },
    editMachine (machine) {
      if (this.isAdmin) {
        this.$router.push(`/edit-machine/${machine._id}`)
      }
    }
  }
}
</script>

<style>
  /* .machines-list .category {
    background-color: #ccc;
    color: #ccc;
  } */

  .machines-list table tr.category th {
    color: #fff;
    background-color: #3273dc;
    border-color: #3273dc;
  }

  .machines-list table.alerts {
    border: solid 2px #333;
  }

  .machines-list table.alerts thead th {
    background-color: #333;
    color: #eee;
  }

  .machines-list table.alerts thead th,
  .machines-list table.alerts tbody td {
    border-color: #333;
  }
</style>
